import React, { Component } from "react";

class MQThreeGreetingsPS extends Component {
  render() {
    const {
      theHomeowners,
      hoTextNote,
      isMemberOfTeam,
      teamMembers,
      agentFirstNames,
      listgenUserFirstName,
      mailingNum,
      currentPS,
      agentSignoff,
      fromMailPro,
      listgenUserID,
      demoAccountHOName,
      // currentArea
    } = this.props;
    // const { mlsNeighborhood } = currentArea;
    // console.log(theHomeowners.length);
    let smallerHOText = false;
    if (theHomeowners.length > 11) {
      smallerHOText = true;
    }
    // let areaCount = mlsNeighborhood.length;
    // console.log("areaCount", areaCount);
    // let smallerAreaStyles;
    // if (areaCount > 30) {
    //   smallerAreaStyles = "medium-area-styles";
    // } else if (areaCount > 40) {
    //   smallerAreaStyles = "small-area-styles";
    // }

    return (
      <div
        className={mailingNum ? `${mailingNum}-greetings-ps` : "greetings-ps"}
      >
        <div className="greetings-ps-title-container">
          <div
            className={`greetings-ps-title ${
              smallerHOText ? "smaller-greetings-ho-text" : ""
            }`}
          >
            Hello{" "}
            {demoAccountHOName && demoAccountHOName.length > 1
              ? "Stacy"
              : theHomeowners}
          </div>
          <div className="greetings-ps-divider" />
        </div>
        <div className="greetings-ps-box">
          {hoTextNote === "<p></p>" ? (
            <div className="greetings-ps-text">
              Please give me a call today!
            </div>
          ) : (
            <div
              className="greetings-ps-text"
              dangerouslySetInnerHTML={{
                __html: hoTextNote,
              }}
            ></div>
          )}

          <div className="agent-signoff">
            <p className="signoff">Warm Regards,</p>

            {fromMailPro == true ? (
              <p className="agent-name">{agentSignoff}</p>
            ) : isMemberOfTeam && teamMembers.length === 2 ? (
              <p className="agent-name">
                {agentFirstNames(listgenUserFirstName, teamMembers)}
              </p>
            ) : (
              <p className="agent-name">{listgenUserFirstName}</p>
            )}
          </div>
          {/* {listgenUserID !== "100030" && currentPS && currentPS.length > 10 && (
            <div className="mq3-ps-line">PS: {currentPS}</div>
          )} */}
        </div>
      </div>
    );
  }
}

export default MQThreeGreetingsPS;
